/**
 * LOUPIOTE - Barre de progression vers la livraison offerte.
 *
 * L'état (le texte, le pourcentage) est décidé par Liquid dans
 * snippets/free-shipping.liquid, parce que le tiroir est re-rendu côté serveur à
 * chaque modification du panier. Ce fichier ne fait qu'animer le remplissage.
 *
 * Ne pas y remettre de pilotage d'état en display:none : c'est ce qui produisait
 * des états transitoires faux quand le re-rendu serveur arrivait après
 * l'animation.
 */
(function () {
  'use strict';

  if (customElements.get('free-shipping-progress-bar')) return;

  class LoupioteFreeShippingBar extends HTMLElement {
    connectedCallback() {
      var cible = parseFloat(this.dataset.percent);
      if (isNaN(cible)) cible = 0;
      cible = Math.max(0, Math.min(100, cible));

      var fill = this.querySelector('.lp-ladder__fill');
      if (!fill) return;

      /* Départ à zéro puis montée vers la cible, pour que le franchissement se
         voie. À chaque re-rendu l'élément est neuf, donc l'animation rejoue :
         c'est voulu. */
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.width = cible + '%';
        });
      });
    }
  }

  customElements.define('free-shipping-progress-bar', LoupioteFreeShippingBar);
})();
